
const loginRoute = {
  path: '/login',
  name: 'login',
  component: () => import('@/views/login/index'),
  meta: {hidden: true}
}
export default loginRoute



// WEBPACK FOOTER //
// ./src/router/modules/login.js